import React from 'react';

/**
 * EnvironmentBanner component displays the current environment (e.g., Development, Staging, Production)
 * at the top of the application UI. Useful for distinguishing between different deployment environments.
 *
 * Props:
 * - environment: string (optional) - The name of the environment to display. If not provided, defaults to process.env.VITE_ENVIRONMENT
 */
const EnvironmentBanner = ({ environment }) => {
    const env = environment || import.meta.env.VITE_ENVIRONMENT;

    if (env === 'production') {
        return null;
    }

    let backgroundColor;
    switch (env) {
        case 'development':
            backgroundColor = '#82d616';
            break;
            '#2196f3'
        case 'testing':
            backgroundColor = '#fbcf33';
            break;
        case 'staging':
            backgroundColor = '#ea0606';
            break;
    }

    const bannerStyle = {
        width: '100%',
        backgroundColor: backgroundColor,
        color: '#fff',
        textAlign: 'center',
        padding: '4px 0',
        fontSize: '14px',
        //position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 10000,
        letterSpacing: '1px',
    };

    return (
        <div style={bannerStyle}>
            {env && env.toUpperCase()} ENVIRONMENT
        </div>
    );
};

export default EnvironmentBanner;